var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import CollectionConfigurationComponent from './../base/CollectionConfigurationComponent';
import ChartNavigatorSeriesItem from './SeriesItem';
import { validateChildren } from '../../utils/main';
var ChartNavigatorSeries = function (props) {
    return (React.createElement(CollectionConfigurationComponent, __assign({}, props, { _chartKey: "series" })));
};
ChartNavigatorSeries.propTypes = {
    children: function (props, propName, componentName) {
        return validateChildren(props, propName, componentName, ChartNavigatorSeriesItem);
    }
};
export default ChartNavigatorSeries;
//# sourceMappingURL=Series.js.map